import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

export const CardPay = ({
  dataLC,
  handleInputChange,
  errors = {},
  setDataLC,
}) => {
  const {
    rfc,
    domicilio,
    nombre,
    apaterno,
    amaterno,
    observaciones,
    tp_persona,
  } = dataLC || {};

  const handleTipoPersonaChange = (event) => {
    handleInputChange(event);
    setDataLC((prev) => ({
      ...prev,
      rfc: "",
      nombre: "",
      apaterno: "",
      amaterno: "",
      domicilio: "",
      observaciones: "",
    }));
  };

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            mb: 1.5,
          }}
        >
          <Typography variant="h6" component="div" sx={{ fontWeight: "600" }}>
            Datos del contribuyente / ciudadano.
          </Typography>

          <RadioGroup
            row
            name="tp_persona"
            value={tp_persona}
            onChange={handleTipoPersonaChange}
          >
            <FormControlLabel
              value="fisica"
              control={
                <Radio
                  sx={{
                    color: "var(--main-color-vino)",
                    "&.Mui-checked": { color: "var(--main-color-vino)" },
                  }}
                />
              }
              label="Persona física"
            />
            <FormControlLabel
              value="moral"
              control={
                <Radio
                  sx={{
                    color: "var(--main-color-vino)",
                    "&.Mui-checked": { color: "var(--main-color-vino)" },
                  }}
                />
              }
              label="Persona moral"
            />
          </RadioGroup>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
        >
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <TextField
                label="RFC"
                variant="outlined"
                size="small"
                fullWidth
                value={rfc}
                onChange={handleInputChange}
                name="rfc"
                inputProps={{ style: { textTransform: "uppercase" } }}
                error={Boolean(errors.rfc)}
                helperText={errors.rfc}
              />
            </Grid>

            {tp_persona === "fisica" ? (
              <>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Nombre(s)"
                    variant="outlined"
                    size="small"
                    value={nombre}
                    onChange={handleInputChange}
                    name="nombre"
                    error={Boolean(errors.nombre)}
                    helperText={errors.nombre}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Apellido paterno"
                    variant="outlined"
                    size="small"
                    value={apaterno}
                    onChange={handleInputChange}
                    name="apaterno"
                    error={Boolean(errors.apaterno)}
                    helperText={errors.apaterno}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Apellido materno"
                    variant="outlined"
                    size="small"
                    value={amaterno}
                    onChange={handleInputChange}
                    name="amaterno"
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Razón Social o Denominación"
                  variant="outlined"
                  size="small"
                  value={nombre}
                  onChange={handleInputChange}
                  name="nombre"
                  error={Boolean(errors.nombre)}
                  helperText={
                    errors.nombre ? "La razón social es obligatoria." : ""
                  }
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Dirección"
                variant="outlined"
                size="small"
                value={domicilio}
                onChange={handleInputChange}
                name="domicilio"
                error={Boolean(errors.domicilio)}
                helperText={errors.domicilio}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observaciones"
                variant="outlined"
                multiline
                rows={4}
                value={observaciones}
                onChange={handleInputChange}
                name="observaciones"
              />
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};
